import { api, HEADERS } from '~config/api';

const getStores = () => api.get('v1/admin/stores?page=1&limit=100');
const getAllStores = () => api.get('v1/admin/stores/all?limit=1000');
const getStoreById = (id) => {
  api.setHeader(HEADERS.ADMIN_STORE_ID, id);
  return api.get(`/v1/admin/stores/${id}`);
};
const updateStore = (store) => {
  api.setHeader(HEADERS.ADMIN_STORE_ID, store.store.id);
  return api.patch(`/v1/admin/stores/${store.store.id}`, store);
};

const getScheduledDateAvailability = ({ id, dispatchMethod }) => {
  return api.get(`v1/stores/${id}/scheduled_date_availability?dispatch_method=${dispatchMethod}`);
};

const getStoreDelivery = ({ latitude, longitude }) => {
  return api.get(`v2/stores/delivery?latitude=${latitude}&longitude=${longitude}`);
};

export default {
  getStores,
  getStoreById,
  updateStore,
  getAllStores,
  getScheduledDateAvailability,
  getStoreDelivery
};
